import { useEffect, useState } from 'preact/hooks'
import { drfFetch, login, router } from '@/core'
import { UNION_COMPANIES } from '@/consts'
import { fetchUserInfo } from '@u/drf/auth'

export function useSamlBootstrap(store) {
  const [booted, setBooted] = useState(false)

  const logoutCheck = () => {
    const token = localStorage?.getItem('token')
    const users = localStorage?.getItem('users')
    if (token && !users) {
      window.localStorage.clear()
      const base = `${window.location.protocol}//${window.location.host}`
      window.location.assign(`${base}/v2/login`)
    }
  }

  useEffect(() => {
    let cancelled = false
    ;(async () => {
      try {
        const url = new URL(window.location.href)
        const code = url.searchParams.get('saml_code')
        // Legacy token param: remove once the backend that sends saml_code is deployed.
        let token = url.searchParams.get('saml_login') && url.searchParams.get('auth_token')
        if (code) {
          window.history.replaceState({}, '', url.origin + url.pathname + url.hash)
          const res = await drfFetch('samlExchange', { method: 'POST', body: { code } })
          token = res.token
          if (
            res.canVolunteerDuringBusinessHours === null &&
            UNION_COMPANIES.some(c => c.toLowerCase() === res.companyName?.toLowerCase())
          ) {
            token = null
            router(store).replace({ name: 'confirmEmployeeType' })
          }
        }

        if (token) {
          localStorage.setItem('token', token)

          const info = await fetchUserInfo({ token })
          if (!cancelled) {
            await login(store, { token, info })
            const clean = url.origin + url.pathname + url.hash
            window.history.replaceState({}, '', clean)
          }
        }
      } catch (e) {
        console.error('SAML bootstrap failed', e)
      } finally {
        if (!cancelled) {
          logoutCheck()
          setBooted(true)
        }
      }
    })()
    return () => {
      cancelled = true
    }
  }, [])

  return { booted }
}
